module.exports = __webpack_public_path__ + "img/full7-min.017ff4c2.png";